import axios from 'axios'
import Configuration from './Api/Configuration'
import { log } from '../utils/helpers'
import { LocalStorageService } from './LocalStorageService'
import { NamedRoutes } from '../routes'

let { BASE_URL } = Configuration


axios.defaults.baseURL = BASE_URL
axios.defaults.headers.common['Content-Type'] = 'application/json'
axios.defaults.headers.common['Accept'] = 'application/json'
// axios.defaults.headers.common['Access-Control-Allow-Methods'] = 'GET, POST, PUT, Patch, OPTIONS'
// axios.defaults.headers.common['Access-Control-Allow-Headers'] = 'Content-Type, Authorization, X-Requested-With'
// axios.defaults.headers.common['Access-Control-Allow-Origin'] = '*'

/**
 *  Add a request interceptor
 */
axios.interceptors.request.use((config) => {
  LocalStorageService.get('EInvoicingLanguage').then((appLanguage) => {
    config.headers['Accept-Language'] = appLanguage
  })
  return config
}, (error) => { log(error) })

axios.interceptors.response.use((response) => {
  return response
}, (error) => {
  return new Promise((resolve, reject) => {
    if (error.response && error.response.status === 401) {
      console.log(error.response.status)
      window.location = NamedRoutes.unAuthorized
    }
    return reject(error)
  })
})
